import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrl } from '../../boot/index.js';

export const getProposal = createAsyncThunk('proposal/getProposal', async (data)=> {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/crm/app/v1/get-proposal`);
        console.log({response});
        return response;
    }
);                      